// extracted by mini-css-extract-plugin
export var Section = "Founders-module--Section--q45De";
export var LangHY = "Founders-module--LangHY--iyFVh";
export var ItemTitle = "Founders-module--ItemTitle--DlXFH";
export var ItemText = "Founders-module--ItemText--ABEQQ";
export var Items = "Founders-module--Items--xLPp-";
export var Item = "Founders-module--Item---VFQ6";
export var ItemImg = "Founders-module--ItemImg--jl2T2";
export var Card = "Founders-module--Card--6ayib";
export var Dash = "Founders-module--Dash--Wu2pt";
export var arrowLeft = "Founders-module--arrowLeft--cMFOB";
export var arrowRight = "Founders-module--arrowRight--kAaH6";